import { post, postExFile } from "@utils/httpUtil";
// 分发元素关系列表
export function distributeElementRelationList(data, config) {
  return post(`/c/pc/distribute/elementRelationList`, data, config);
}
// 创建分发记录
export function distributeCreateDistributePlan(data, config) {
  return post(`/c/pc/distribute/createDistributePlan`, data, config);
}
// 分页查询文章分发记录
export function distributeArticlePageList(data, config) {
  return post(`/c/pc/distribute/pageList/article`, data, config);
}
// 导出文章详情分发记录
export function distributeRecordExport(data, config) {
  return postExFile(`/c/pc/distribute/pageList/article/export`, data, config);
}
// 取消分发记录
export function distributeCancelById(data, config) {
  return post(`/c/pc/distribute/cancelById`, data, config);
}
// 查询社区指定分享配置
export function shareConfigFindConfigByElement(data, config) {
  return post(`/c/pc/shareConfig/findConfigByElement`, data, config);
}
// 保存或更新分享配置
export function shareConfigSaveConfig(data, config) {
  return post(`/c/pc/shareConfig/saveConfig`, data, config);
}
// 编辑分发记录
export function updateDistributePlan(data, config) {
  return post(`/c/pc/distribute/updateDistributePlan`, data, config);
}
// 查询公众号二维码
export function findOfficialAccountQRCode(data, config) {
  return post(`/c/pc/shareConfig/findOfficialAccountQRCode`, data, config);
}
// 查询小程序二维码
export function findMiniProgramQRCode(data, config) {
  return post(`/c/pc/shareConfig/findMiniProgramQRCode`, data, config);
}
// 查询平台小程序二维码
export function findPlatformMiniProgramQRCode(data, config) {
  return post(`/c/pc/shareConfig/findPlatformMiniProgramQRCode`, data, config);
}